import { PawPrint, Check, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story Owner Panel 3: Mockup okna panelu organizacji
 */
export const InstagramStoryOwnerPanel3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "140px 72px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            background: "#2D5A3D",
            padding: "12px 26px",
            borderRadius: "999px",
            marginBottom: "20px",
          }}
        >
          <Sparkles style={{ width: "24px", height: "24px", color: "#FFFFFF" }} />
          <span style={{ fontSize: "24px", fontWeight: 800, color: "#FFFFFF", letterSpacing: "0.08em", textTransform: "uppercase" }}>
            Nowość dla schronisk
          </span>
        </div>

        <h1 style={{ fontSize: "82px", fontWeight: 900, color: "#2D5A3D", margin: "0 0 16px", textAlign: "center", lineHeight: 1.05 }}>
          Panel organizacji<br />jest już dostępny
        </h1>
        <p style={{ fontSize: "32px", fontWeight: 600, color: "#5A8A70", margin: "0 0 32px", textAlign: "center", lineHeight: 1.3, maxWidth: "920px" }}>
          Wolontariusz albo pracownik schroniska może założyć konto i aktualizować potrzeby - łatwo i bezpłatnie 💚
        </p>

        {/* Mockup window */}
        <div
          style={{
            width: "100%",
            maxWidth: "920px",
            background: "#FFFFFF",
            borderRadius: "32px",
            boxShadow: "0 24px 60px rgba(15,42,28,0.32), 0 8px 18px rgba(15,42,28,0.18)",
            overflow: "hidden",
            border: "1px solid rgba(45,90,61,0.1)",
          }}
        >
          {/* Window header */}
          <div style={{ background: "#F5F8F6", padding: "20px 28px", display: "flex", alignItems: "center", gap: "10px", borderBottom: "1px solid rgba(45,90,61,0.08)" }}>
            <div style={{ width: "14px", height: "14px", borderRadius: "50%", background: "#FF6B6B" }} />
            <div style={{ width: "14px", height: "14px", borderRadius: "50%", background: "#FFD93D" }} />
            <div style={{ width: "14px", height: "14px", borderRadius: "50%", background: "#6BCB77" }} />
            <p style={{ fontSize: "22px", fontWeight: 700, color: "#5A8A70", margin: "0 0 0 20px" }}>
              gdzieschronisko.pl/panel
            </p>
          </div>

          {/* Window content */}
          <div style={{ padding: "44px 40px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
              {[
                { text: "Aktualizuj potrzeby i oznaczaj jako pilne", highlight: true },
                { text: "Edytuj dane organizacji", highlight: false },
                { text: "Sprawdzaj statystyki wyświetleń", highlight: false },
              ].map(({ text, highlight }) => (
                <div key={text} style={{ display: "flex", alignItems: "center", gap: "18px", background: highlight ? "#FFF7ED" : "#F5F8F6", padding: "22px 26px", borderRadius: "18px", border: highlight ? "2px solid #FDBA74" : "none" }}>
                  <div style={{ background: highlight ? "#F59E0B" : "#2D5A3D", borderRadius: "50%", width: "44px", height: "44px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <Check style={{ width: "26px", height: "26px", color: "#FFFFFF" }} strokeWidth={3} />
                  </div>
                  <p style={{ fontSize: "30px", fontWeight: 800, color: highlight ? "#D97706" : "#2D5A3D", margin: 0, lineHeight: 1.25 }}>
                    {text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D", margin: "36px 0 0", textAlign: "center", lineHeight: 1.3 }}>
          Załóż konto: gdzieschronisko.pl/panel
        </p>
      </div>

      <div style={{ padding: "0 80px 60px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
